// Embeddable widget: keep the host page's <iframe> sized to our content.
//
// The widget site renders inside an iframe on third-party pages (see
// src/public/assets/widget.js, the script those pages include). We post our
// document height to the parent every 300ms; widget.js listens and resizes.
// Only the widget layout renders #widget-container, so this is a no-op on the
// main site.
import { onReady } from './dom.js';

onReady(function () {
    if (!document.getElementById('widget-container')) return;

    window.addEventListener('load', function () {
        setInterval(function () {
            window.parent.postMessage(
                { height: document.documentElement.getBoundingClientRect().height },
                '*'
            );
        }, 300);
    });
});
